var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297 1045L297 1073",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.5,
    cy: 1040.33,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.987 1040.19C292.987 1036.28 296.288 1033.12 300.358 1033.12C300.943 1033.12 301.511 1033.18 302.056 1033.31C300.742 1032.48 299.187 1032 297.519 1032C292.814 1032 289 1035.81 289 1040.5C289 1045.19 292.814 1049 297.519 1049C299.814 1049 301.895 1048.09 303.427 1046.62C302.492 1047.03 301.454 1047.26 300.358 1047.26C296.288 1047.26 292.987 1044.1 292.987 1040.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.402 1039.6L306.37 1037.15L304.536 1038.72L302.304 1038.06L303.112 1040.34L301.765 1042.38L304.1 1042.22L305.499 1044.14L306.133 1041.76L308.345 1040.91L306.402 1039.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.f57249a2039b14ef933765aa564822cd.svg";
export { ForwardRef as ReactComponent };